"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const AuthContext_1 = __importDefault(require("./AuthContext"));
const useAuthReducer_1 = __importDefault(require("./useAuthReducer"));
function AuthProvider({ children, client, onLoading, ...authReducerOptions }) {
    const [state, dispatch] = useAuthReducer_1.default(authReducerOptions);
    const [isWebPageVisible, setIsWebPageVisible] = react_1.useState(true);
    react_1.useEffect(() => {
        if (react_native_1.Platform.OS !== 'web')
            return;
        document.onvisibilitychange = document.onvisibilitychange = () => {
            setIsWebPageVisible(document.hidden);
        };
    }, []);
    react_1.useEffect(() => {
        if (onLoading)
            onLoading(state.isLoading);
    }, [state.isLoading, onLoading]);
    react_1.useEffect(() => {
        const bootstrap = async () => {
            try {
                const result = await client.bootstrap();
                dispatch({ type: 'BOOTSTRAP', payload: result });
            }
            catch (error) {
                dispatch({ type: 'ERROR', payload: { error } });
            }
        };
        if (isWebPageVisible)
            bootstrap();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [client, isWebPageVisible]);
    return state.isLoading
        ? null
        : react_1.default.createElement(AuthContext_1.default.Provider, { value: { client, dispatch, state } }, children);
}
exports.default = AuthProvider;
